import { NgIf } from '@angular/common';
import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import {
  EItemPriority,
  getItemPriorityTranslationKey,
  IItemPriorityStyle,
  itemPriorityStyle,
} from './item-priority.interface';

@Component({
  imports: [MatIcon, MatTooltip, NgIf, TranslateModule],
  selector: 'app-item-priority',
  standalone: true,
  styleUrl: './item-priority.component.scss',
  templateUrl: './item-priority.component.html',
})
export class ItemPriorityComponent {
  public readonly priority: InputSignal<EItemPriority | null | undefined> = input<EItemPriority | null>();
  public readonly showLabel: InputSignal<boolean> = input(false);
  public readonly hasTooltip: InputSignal<boolean> = input(true);
  public readonly icon: Signal<string | null> = computed(() => this.style()?.icon ?? null);
  public readonly color: Signal<string | null> = computed(() => this.style()?.color ?? null);

  public readonly style: Signal<IItemPriorityStyle | null> = computed(() => {
    const priority: EItemPriority | null | undefined = this.priority();

    return priority ? itemPriorityStyle[priority] : null;
  });

  public readonly labelKey: Signal<string | null> = computed(() => {
    const priority: EItemPriority | null | undefined = this.priority();

    return priority ? getItemPriorityTranslationKey(priority) : null;
  });
}
